import { Posting } from 'app/library/posting/models/posting.model';
import * as momentImported from 'moment';
import { IScheduledStreamContentQuery } from '../interfaces/scheduled-stream-content.query.interface';
const moment = momentImported;

// @dynamic
export class MaxBrainScheduledStreamContent {
    static label_singular = 'scheduledStreamContent';
    static label_plural = 'scheduledStreamContents';

    static props_to_search = ['name', 'posting', 'translations', 'title'];

    id: string;
    audience: { id: string };
    posting: Posting;
    featuredStream: { id: string };
    priority: string;
    startDate: Date;
    endDate: Date;
    liveCategoryLink: { id: string; category: { id: string; name: string; type: string } };

    constructor(query?: IScheduledStreamContentQuery) {
        if (query) {
            this.id = query.id.toString();
            this.audience = { id: query.audience.id.toString() };
            this.posting = new Posting(query.posting);
            this.featuredStream = { id: query.featured_stream.id.toString() };
            this.priority = query.priority;
            this.startDate = query.start_date;
            this.endDate = query.end_date;
            this.liveCategoryLink = query.live_category_link
                ? {
                      id: query.live_category_link.id.toString(),
                      category: {
                          id: query.live_category_link.category.id.toString(),
                          name: query.live_category_link.category.name,
                          type: query.live_category_link.category.type,
                      },
                  }
                : null;
        }
    }
}
